import './main.less';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isNull from 'lodash/isNull';
import _get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { actions, selectors } from '../../../../modules/survey';
import { keys } from './enums';

import { enum as niches } from '../../../../../../enums/niches';
import { enum as trafficSources } from '../../../../../../enums/traffic-sources';

class Survey extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			survey: {
				locations: [],
				trafficSources: [],
				niches: [],
				experience: undefined
			},
			otherNicheField: '',
			otherTrafficSourceField: '',
			canSubmit: false
		};
	}

	componentDidMount() {
		this.props.getTargetingLocations();
		if (isNull(this.props.user.general.manager_id)) {
			this.props.setManager();
		}
		const isInitialShowWelcomePage = window.localStorage.getItem('isInitialShowWelcomePage');

		if (!isInitialShowWelcomePage) {
			window.localStorage.setItem('isInitialShowWelcomePage', true);
			window.dataLayer.push({
				'event': 'formSuccess',
				'eventCategory': 'surveyPage',
				'customerBillingEmail': this.props.user.general.email
			});
			gtag('event', 'formSuccess', {
				'event': 'formSuccess',
				'eventCategory': 'surveyPage',
				'customerBillingEmail': this.props.user.general.email
			});
		}
	}

	updateCanSubmit() {
		const survey = this.state.survey;
		if (survey.locations.length > 0 &&
			survey.trafficSources.length > 0 &&
			(
				(survey.trafficSources.includes(trafficSources.other) && this.state.otherTrafficSourceField) ||
				!survey.trafficSources.includes(trafficSources.other)
			) &&
			survey.niches.length > 0 &&
			(
				(survey.niches.includes(niches.other) && this.state.otherNicheField) ||
				!survey.niches.includes(niches.other)
			) &&
			survey.experience) {
			this.setState({ canSubmit: true });
		} else this.setState({ canSubmit: false });
	}

	onRadioChange(key, option) {
		const survey = this.state.survey;
		survey[key] = option.id;
		this.setState({ ...survey }, () => this.updateCanSubmit());
	}

	onCheckboxChange(key, option, e) {
		const survey = this.state.survey;
		const value = e.target.value === 'true';
		const newValue = !value;
		if (newValue) survey[key].push(option.id);
		else survey[key].splice(survey[key].indexOf(option.id, 1));
		this.setState({ ...survey }, () => this.updateCanSubmit());
		if (key === keys.niches && option.id === niches.other && !newValue) {
			this.setState({ otherNicheField: '' });
		}
		if (key === keys.trafficSources && option.id === trafficSources.other && !newValue) {
			this.setState({ otherTrafficSourceField: '' });
		}
	}

	onOtherNicheFieldChange(e) {
		this.setState({ otherNicheField: e.target.value }, () => this.updateCanSubmit());
	}

	onOtherTrafficSourceFieldChange(e) {
		this.setState({ otherTrafficSourceField: e.target.value }, () => this.updateCanSubmit());
	}

	onSubmit() {
		if (this.state.canSubmit) {
			const survey = cloneDeep(this.state.survey);
			if (survey.niches.includes(niches.other)) {
				survey.niches.splice(survey.niches.indexOf(niches.other), 1, this.state.otherNicheField);
			}
			if (survey.trafficSources.includes(trafficSources.other)) {
				survey.trafficSources.splice(
					survey.trafficSources.indexOf(trafficSources.other),
					1,
					this.state.otherTrafficSourceField
				);
			}
			this.props.saveSurvey(survey);
		}
	}

	render() {
		const { intl } = this.props;

		const telegram = getTelegram(this.props.managerContacts && this.props.managerContacts.telegram);

		return (
			<div className="survey-container">
				<div className="survey-content">
					<div className="survey">
						<div className="survey-welcome-title">
							{intl('Добро пожаловать в Everad!')}
						</div>
						<div className="survey-info">
							{intl('Для активации аккаунта свяжитесь с вашим менеджером в Telegram.')}
						</div>
						<div className="manager-contacts">
							{
								!!telegram &&
								<a
									href={`https://t.me/${telegram}`}
									target="_blank"
									className="messenger_address button yellow-btn font-proxima-nova-semibold telegram"
								>
									{intl('Активировать в') + ' Telegram'}
								</a>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		targetingLocations: selectors.getTargetingLocations(state),
		trafficSources: selectors.getTrafficSources(state),
		niches: selectors.getNiches(state),
		config: _get(state, 'app.config', {}),
		user: selectors.getUserData(state),
		managerContacts: selectors.getManagerContacts(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Survey);

function getTelegram(tg = '') {
	return tg.startsWith('@') ? tg.replace('@', '') : `${tg}`;
}


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/survey/main.js